import { createContext } from 'react';
export const AlgoliaAppContext = createContext(null);
